export type MetaCategoria = 'evaluacion' | 'ejercicio' | 'habito';

export type MetaEstado = 'active' | 'completed' | 'cancelled';

export interface Meta {
  id: number;
  intus_goal_id: number;
  titulo: string;
  descripcion: string | null;
  categoria: MetaCategoria;
  fechaLimite: string | null;
  progreso: number;
  estado: MetaEstado;
  ultimaActividad: string | null;
  createdAt: string;
  updatedAt: string;
}

export const CATEGORIA_LABELS: Record<MetaCategoria, string> = {
  evaluacion: 'Evaluación',
  ejercicio: 'Ejercicio',
  habito: 'Hábito',
};

export const CATEGORIA_COLORS: Record<MetaCategoria, string> = {
  evaluacion: 'bg-purple-100 text-purple-700',
  ejercicio: 'bg-pink-100 text-pink-700',
  habito: 'bg-amber-100 text-amber-700',
};
